












































import { computed, defineComponent, getCurrentInstance, ref } from '@vue/composition-api'

import { resolveManualAssetUrl } from '@/utils/manual/loader'
import { ExcelManual } from '@/utils/manual/types'

export default defineComponent({
  name: 'HExcelManualModal',
  setup() {
    const instance = getCurrentInstance()
    const manual = ref<ExcelManual | null>(null)
    const routePath = ref('/h')

    const modalTitle = computed(() => {
      if (!manual.value) {
        return 'Excelの説明'
      }
      return `Excelの説明（${manual.value.excelName}）`
    })

    const columnFields = [
      { key: 'name', label: '列名' },
      { key: 'description', label: '説明' },
    ]

    const show = (doc: ExcelManual, path: string) => {
      manual.value = doc
      routePath.value = path
      // @ts-ignore
      instance.proxy.$refs.modal.show()
    }

    const resolveImage = (image: string) => {
      return resolveManualAssetUrl(routePath.value, image)
    }

    return {
      manual,
      modalTitle,
      columnFields,
      show,
      resolveImage,
    }
  },
})
